module.exports = __webpack_public_path__ + "static/media/img48.19641738.jpg";